"use client";

import { cn } from "@/lib/utils";

export type OrgProjectOption = {
  id: string;
  name: string;
  color?: string | null;
};

type OrgProjectColorDotProps = {
  color?: string | null;
  className?: string;
};

export const OrgProjectColorDot = ({ color, className }: OrgProjectColorDotProps) => (
  <span
    className={cn("inline-block size-2.5 shrink-0 rounded-full", className)}
    style={{ backgroundColor: color || "var(--muted-foreground)" }}
    aria-hidden
  />
);

type OrgProjectChipProps = {
  name: string;
  color?: string | null;
  className?: string;
};

export const OrgProjectChip = ({ name, color, className }: OrgProjectChipProps) => (
  <span
    className={cn("inline-flex items-center gap-1.5 rounded-md bg-muted/60 px-2 py-0.5 text-xs font-medium", className)}
  >
    <OrgProjectColorDot color={color} />
    {name}
  </span>
);
